module.exports = __webpack_public_path__ + "static/media/about-hungry.3f3e3f52.svg";